import React, { useEffect } from "react";
import { connect } from "react-redux";

import Table, { TablePaginationConfig } from "antd/es/table";
import { useIntl } from "react-intl";
import { Link, useRouteMatch } from "react-router-dom";

import { Button } from "@mapmycustomers/ui";

import { downloadFile } from "@app/store/files/actions";
import { RootState } from "@app/store/rootReducer";

import SettingPage from "../../common/SettingPage";
import { initializeMainPage } from "../store/actions";
import { getImportHistory } from "../store/selectors";
import ImportHistoryRow from "../type/ImportHistoryRow";

import styles from "./ImportHistory.module.scss";
import useHistoryTableConfig from "./useHistoryTableConfig";

const paginationConfig: TablePaginationConfig = {
  pageSize: 10,
  position: ["bottomCenter"],
  showSizeChanger: false,
};

interface Props {
  downloadFile: typeof downloadFile;
  history: ImportHistoryRow[];
  initialize: typeof initializeMainPage.request;
}

const ImportHistory: React.FC<Props> = ({ downloadFile, history, initialize }) => {
  const intl = useIntl();
  const historyTableConfig = useHistoryTableConfig(intl, downloadFile);
  const { path } = useRouteMatch();

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <SettingPage
      actions={
        <Link to={`${path.replace("import-history", "new-import")}`}>
          <Button type="primary">
            {intl.formatMessage({
              id: "setting.importsHistory.newImport.button",
              defaultMessage: "New Import",
              description: "Text of new import button",
            })}
          </Button>
        </Link>
      }
      title={intl.formatMessage({
        id: "settings.importsHistory.title",
        defaultMessage: "Import History",
        description: "Title of settings import history page",
      })}
    >
      <div>
        <Table<ImportHistoryRow>
          className={styles.mappingTable}
          columns={historyTableConfig}
          dataSource={history}
          pagination={paginationConfig}
          rowKey="id"
        />
      </div>
    </SettingPage>
  );
};

const mapDispatchToProps = {
  downloadFile,
  initialize: initializeMainPage.request,
};

const mapStateToProps = (state: RootState) => ({
  history: getImportHistory(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportHistory);
